import { render } from "./ProjectTickets.vue?vue&type=template&id=17087155&scoped=true&ts=true"
import script from "./ProjectTickets.ts?vue&type=script&lang=ts"
export * from "./ProjectTickets.ts?vue&type=script&lang=ts"

import "./ProjectTickets.vue?vue&type=style&index=0&id=17087155&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17087155"]])

export default __exports__